module.exports = __webpack_public_path__ + "static/media/saucesKetchups.f9fee679.webp";